import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  typography: {
    fontSize: 16,
  },
  buttonDownloadModel: {
    margin: theme.spacing(2.5, 0),
    width: '30%',
    paddingInline: '12px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dropzone: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `2px ${theme.palette.primary.main} dashed`,
    borderRadius: '5px',
    color: theme.palette.primary.main,
    flexDirection: 'column',
    cursor: 'pointer',
  },
}))

export default useStyles
